import React from 'react';
import GestionAbstract from '../../components/forms/gestion-abstract';
import ICouleur from '../../models/ICouleur';
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';

interface IGestionCouleursProps {
  isModeSelection?: boolean;
}

class Couleur extends IBaseModel implements ICouleur {
  idCouleur: Guid = Guid.empty;
}

export default function GestionCouleurs({ isModeSelection }: IGestionCouleursProps) {
  return (
    <GestionAbstract isModeSelection={isModeSelection} path="Couleur" model={Couleur} />
  );
}